import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";

/**
 * Performs an arbitrary non-navigation action.
 */
export class SidebarButtonActionComponent {
    public constructor(
        public readonly label: string, 
        public readonly icon: SvgIcon, 
        public readonly disabled: boolean) {
        
    }

    public getIconSvg(): string {
        return SvgIconMap.get(this.icon)!;
    }

    public onClick(): void {
        // ... implement in child ...
    }
}